import { jsxs as s, jsx as e } from "react/jsx-runtime";
const i = ({ className: t, width: o = 51, height: r = 64 }) => /* @__PURE__ */ s("svg", { className: t, width: o, height: r, viewBox: "0 0 51 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ e("path", { d: "M0.119141 2.57388C0.119141 1.34734 1.11344 0.353021 2.33999 0.353004L35.5538 0.352539L50.882 14.9835V61.4271C50.882 62.6537 49.8877 63.648 48.6611 63.648H2.34002C1.11346 63.648 0.119141 62.6537 0.119141 61.4271V2.57388Z", fill: "#FFDADA" }),
  /* @__PURE__ */ e("path", { d: "M19 37.9999L30.9999 26M19 26.0001L30.9999 38", stroke: "#F36578", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" })
] });
export {
  i as default
};
